module.exports = __webpack_public_path__ + "img/nofoldersearch.bf55e59a.svg";